import { authService } from 'modules/auth/services/authService';
import type { QuenteAgoraFiltro, QuenteAgoraItem, QuenteAgoraLista, QuenteAgoraMetricas, QuenteEscopo } from './tipos';

/**
 * A fila "Quente agora" (`src/Rocky.Modules.CRM/Features/Prospeccao/QuenteAgoraEndpoints.cs`).
 *
 *   GET  /api/crm/quente-agora?escopo&produtoFamiliaId&prioridade   (MINHAS = minhas + sem dono)
 *   GET  /api/crm/quente-agora/metricas?escopo&dias
 *   POST /api/crm/quente-agora/{id}/atender
 *   POST /api/crm/quente-agora/{id}/dispensar
 *   POST /api/crm/quente-agora/{id}/atribuir                        ({ userId } — nulo = para mim)
 *
 * TODAS e atribuir a outra pessoa pedem `crm.quente.ver_todas` (403 sem ela). 409 = o item já
 * saiu da fila (outra pessoa atendeu, expirou).
 */
const BASE = '/api/crm/quente-agora';

const qs = (params: Record<string, string | number | null | undefined>): string => {
  const e = Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '');
  return e.length ? '?' + e.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`).join('&') : '';
};

/** Avisa o contador do menu de que a fila mudou (atendeu, dispensou, chegou evento). */
export const EVENTO_QUENTE_MUDOU = 'rocky:quente-agora-mudou';
export const avisarQuenteMudou = (): void => {
  try {
    window.dispatchEvent(new Event(EVENTO_QUENTE_MUDOU));
  } catch {
    /* fora do navegador: nada a avisar */
  }
};

export const quenteAgoraService = {
  listar: async (f: QuenteAgoraFiltro): Promise<QuenteAgoraLista> =>
    (await authService.authFetch<QuenteAgoraLista>(`${BASE}${qs({ ...f })}`)) ?? { itens: [], total: 0 },

  metricas: (escopo: QuenteEscopo, dias = 7) => authService.authFetch<QuenteAgoraMetricas>(`${BASE}/metricas${qs({ escopo, dias })}`),

  atender: (id: number) => authService.authFetch<QuenteAgoraItem>(`${BASE}/${id}/atender`, { method: 'POST' }),

  dispensar: (id: number) => authService.authFetch<QuenteAgoraItem>(`${BASE}/${id}/dispensar`, { method: 'POST' }),

  /** `userId` nulo = assumir para mim. */
  atribuir: (id: number, userId: string | null) =>
    authService.authFetch<QuenteAgoraItem>(`${BASE}/${id}/atribuir`, { method: 'POST', body: JSON.stringify({ userId }) })
};
